var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "32px",
    height: "32.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70747c",
    d: "M918.74 303.432c0.65 9.096 0.65 18.194 0.65 27.29 0 277.44-211.166 597.116-597.116 597.116-118.904 0-229.36-34.438-322.274-94.212 16.894 1.948 33.136 2.598 50.68 2.598 98.11 0 188.426-33.136 260.548-89.664-92.264-1.95-169.584-62.376-196.224-145.544 12.996 1.948 25.99 3.248 39.636 3.248 18.842 0 37.686-2.6 55.228-7.146-96.162-19.494-168.286-103.96-168.286-205.97v-2.598c27.938 15.594 60.428 25.34 94.862 26.638-56.528-37.686-93.562-102.01-93.562-174.782 0-38.984 10.394-74.72 28.588-105.908 103.31 127.35 258.6 210.516 432.73 219.614-3.248-15.594-5.198-31.836-5.198-48.08 0-115.656 93.564-209.868 209.868-209.868 60.426 0 115.004 25.34 153.34 66.274 47.43-9.096 92.912-26.64 133.198-50.68-15.596 48.732-48.732 89.666-92.264 115.654 42.234-4.546 83.168-16.244 120.852-32.486-28.584 41.582-64.322 78.616-105.256 108.506z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.39e377e9e261172d9a650a8df8ec303c.svg";
export { ForwardRef as ReactComponent };